import { render, staticRenderFns } from "./ChatGPTHistory.vue?vue&type=template&id=167b4db3&scoped=true&"
import script from "./ChatGPTHistory.vue?vue&type=script&lang=js&"
export * from "./ChatGPTHistory.vue?vue&type=script&lang=js&"
import style0 from "./ChatGPTHistory.vue?vue&type=style&index=0&id=167b4db3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167b4db3",
  null
  
)

export default component.exports